// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-619e5737] {\n  font-weight: bold;\n  font-size: 16px;\n  margin: 10px 0;\n}", ""]);
// Exports
module.exports = exports;
